import { Order } from "../../utils/orderTable";

export interface Row {
	room: string;
	category: string;
	nurseName: string;
	nurseClassx: string;
	secondaryNurseName: string;
	secondaryNurseClassx: string;
	areaId: string;
	dateOfAdmission: string;
}

export function createRow(
	room: string,
	category: string,
	nurseName: string,
	nurseClassx: string,
	secondaryNurseName: string,
	secondaryNurseClassx: string,
	areaId: string,
	dateOfAdmission: string,
): Row {
	return {
		room,
		category,
		nurseName,
		nurseClassx,
		secondaryNurseName,
		secondaryNurseClassx,
		areaId,
		dateOfAdmission,
	};
}

export interface HeadCell {
	id: keyof Row;
	label: string;
	width: string;
}

export interface TableHeadersProps {
	onRequestSort: (event: React.MouseEvent<unknown>, property: keyof Row) => void;
	order: Order;
	orderBy: string;
}

export const headCells: readonly HeadCell[] = [
	{
		id: "room",
		label: "Habitación",
		width: "7",
	},
	{
		id: "category",
		label: "Categoría",
		width: "6",
	},
	{
		id: "nurseName",
		label: "Profesional",
		width: "25",
	},
	{
		id: "secondaryNurseName",
		label: "Profesional Auxiliar",
		width: "25",
	},
];
